module.exports = __webpack_public_path__ + "static/media/dentalroom.f93462dc.jpg";